import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { Button } from '~common/components';

const OpenDraftInvoicesDialog = ({
  open,
  loading,
  result,
  onClose,
  onSubmit,
}) => {
  const [dryRun, setDryRun] = useState(true);

  useEffect(() => {
    if (open) {
      setDryRun(true);
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Open Tutor Draft Invoices</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2}>
          <Alert severity="warning">
            This will process every tutor draft invoice in staging. Valid invoices are marked as open,
            and admins receive notifications for successes and per-invoice failures.
          </Alert>
          <FormControlLabel
            control={(
              <Switch
                checked={dryRun}
                onChange={(event) => setDryRun(event.target.checked)}
                disabled={loading}
              />
            )}
            label="Dry run only"
          />
          <Typography variant="body2">
            Dry run creates the same admin notifications but does not update invoice statuses.
          </Typography>
          {result && (
            <Alert severity={result.failedCount > 0 ? 'warning' : 'success'}>
              {result.openedCount} invoices {result.dryRun ? 'would be opened' : 'opened'}.
              {' '}
              {result.failedCount} invoices failed validation.
            </Alert>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onSubmit(dryRun)}
          disabled={loading}
        >
          {dryRun ? 'Run Dry Run' : 'Open Draft Invoices'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

OpenDraftInvoicesDialog.defaultProps = {
  result: null,
};

OpenDraftInvoicesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  result: PropTypes.shape({
    dryRun: PropTypes.bool.isRequired,
    openedCount: PropTypes.number.isRequired,
    failedCount: PropTypes.number.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default OpenDraftInvoicesDialog;
